<template>
  <v-bottom-sheet v-model="showBottomSheet" inset>
    <template v-slot:activator="{ on, attrs }">
      <!-- 채널톡과 크기 맞추기 위해 -->
      <!-- 채널톡은 768px도 대형으로 인식함? -->
      <template v-if="$vuetify.breakpoint.width < 768">
        <v-footer fixed style="margin-bottom: 18px">
          <v-layout class="px-1">
            <v-btn
              width="44"
              height="44"
              small
              fab
              bottom
              left
              v-bind="attrs"
              v-on="on"
              color="primary"
              class="mt-6 mr-6"
            >
              <v-icon>mdi-filter-plus</v-icon>
            </v-btn>
          </v-layout>
        </v-footer>
      </template>
      <template v-else>
        <v-footer fixed class="mb-6">
          <v-layout class="px-3">
            <v-btn fab bottom left v-bind="attrs" v-on="on" color="primary" class="mt-6 mr-6">
              <v-icon>mdi-filter-plus</v-icon>
            </v-btn>
          </v-layout>
        </v-footer>
      </template>
    </template>

    <v-card>
      <v-list class="pb-12">
        <v-list-item class="px-0 pb-2" v-for="item in items" :key="'item' + item.title">
          <v-list-item-content class="px-4">
            <v-list-item-title class="font-weight-black font-size--16 mb-11">
              {{ item.title }}
            </v-list-item-title>

            <v-range-slider
              v-model="item.tmpRange"
              :min="item.min"
              :max="item.max"
              :step="item.step"
              hide-details
              class="align-center px-2"
              :thumb-size="36"
              thumb-label="always"
              color="primary"
              track-color="grey lighten-2"
              validate-on-blur
              @mouseup="item.range = item.tmpRange"
            >
              <template v-slot:thumb-label="{ value }">
                {{ item.toLabel(value) }}
              </template>
            </v-range-slider>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      showBottomSheet: false,
    }
  },

  created() {
    this.items.forEach((item) => {
      item.tmpRange = item.range
    })
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-slider__thumb-label {
  letter-spacing: -0.7px;
  font-weight: 700;
  width: 40px !important;
  height: 40px !important;
}

.v-card {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
